"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const joi_1 = __importDefault(require("joi"));
const common_1 = __importDefault(require("./common"));
const validator = (schema) => (payload) => schema.validate(payload, { abortEarly: false, convert: true });
const SendVerificationInviteEmailSchema = joi_1.default.object({
    email: common_1.default.email.required(),
    clientTransformationId: joi_1.default.string().required(),
    clientName: common_1.default.name.required(),
});
module.exports = {
    SendVerificationInviteEmailSchema: validator(SendVerificationInviteEmailSchema),
};
//# sourceMappingURL=trainer.js.map